import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { getContent, getErrorCode } from '../../../util/responseUtil';
import API_AUTHENTICATION from '../../../api/apiAuthentication';
import ActionType from '../../../redux/reducer/globalActionType';
import IconAlert from '../../../components/Alert/IconAlert';
import API_CHAT from '../../../api/apiChat';

class GrochatLogin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            token: '',
            internalToken: '',
            refreshToken: '',
            username: '',
            detailUser: '',
            message: {
                title: '',
                desc: '',
                isSuccess: false
            }
        }
    }

    postGrochatLogin = () => {
        const params = new URLSearchParams(this.props.location.search);
        const data = {
            request_id: params.get('request_id'),
            authorization_code: params.get('auth_code'),
            code_verifier: localStorage.getItem('requestId')
        }

        return API_AUTHENTICATION.postGrochatLogin(data)
            .then(res => {
                this.setState({
                    token: getContent(res).token,
                    refreshToken: getContent(res).refresh_token,
                    username: getContent(res).user.username
                })

                return true
            }).catch(async err => {
                if (getErrorCode(err) === 'E-4-CARE-SRV-018') {
                    await this.setState({
                        message: {
                            title: 'Login Gagal',
                            desc: 'Akun Anda telah login di perangkat lain, silahkan logout terlebih dahulu!',
                            isSuccess: false
                        }
                    })
                    return false
                }

                if (getErrorCode(err) === 'IS_USER_ACTIVE') {
                    await this.setState({
                        message: {
                            title: 'Login Gagal',
                            desc: 'User Anda sudah tidak aktif, Silahkan hubungi Customer Service untuk diaktifkan kembali!',
                            isSuccess: false
                        }
                    })
                    return false
                }
            })
    }

    getInternalToken = () => {
        return API_AUTHENTICATION.getGrochatInternalToken()
            .then(res => {
                this.setState({ internalToken: getContent(res) });
            }).catch(err => {
                console.log(err);
            })
    }

    postDetailUser = () => {
        const dataDetailUser = {
            username: this.state.username
        }

        return API_AUTHENTICATION.postDetailUser(dataDetailUser)
            .then(res => {
                this.setState({ detailUser: getContent(res) });
            }).catch(err => {
                console.log(err);
            })
    }

    getSignByClientId = () => {
        return API_CHAT.getSignByClientId(this.state.detailUser.client_id, this.state.token)
            .then(res => {
                this.setState({ sign: res.data.data.payload.sign_uuid });
            }).catch(err => {
                console.log(err);
            })
    }

    grochatLogin = async () => {
        const isSuccess = await this.postGrochatLogin();
        if (!isSuccess) {
            localStorage.removeItem('requestId');
            return
        }

        await this.getInternalToken();
        await this.postDetailUser();
        await this.getSignByClientId();

        this.props.handleLogin(this.state.sign, this.state.token, this.state.internalToken, this.state.refreshToken, this.state.detailUser);

        await this.setState({
            message: {
                title: 'Berhasil masuk NexCare!',
                desc: 'Anda akan berpindah halaman dalam beberapa saat...',
                isSuccess: true
            }
        })

        this.handleRedirect(this.state.token);
    }

    handleRedirect = (token) => {
        localStorage.removeItem('requestId');
        localStorage.setItem('isGrochatAuthenticated', true);
        localStorage.setItem('userToken', token);

        setTimeout(() => window.close(), 1500);
    }

    componentDidMount() {
        this.grochatLogin();
    }

    render() {
        return (
            <div className="w-screen h-screen justify-center items-center text-center">
                {
                    (this.state.message.title && this.state.message.desc)
                    && <div className="w-full h-full flex flex-col justify-center">
                        {
                            this.state.message.isSuccess
                                ? <div className="flex justify-center mb-3"><IconAlert icon="success" /></div>
                                : <div className="flex justify-center mb-3"><IconAlert icon="warning" /></div>
                        }
                        <p className="text-2xl font-medium whitespace-normal mb-3">{this.state.message.title}</p>
                        <p className="text-xl whitespace-normal">{this.state.message.desc}</p>
                    </div>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        login: state.authentication.login,
        token: state.authentication.token
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogin: (sign, token, internalToken, refreshToken, userDetail) => dispatch({
            type: ActionType.IS_LOGIN,
            payload: {
                sign,
                token,
                internalToken,
                refreshToken,
                userDetail,
                tncAccepted: false
            }
        })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(GrochatLogin));
